<template>
  <div>
    <div class="luckyDraw">
      <turntable />
      <rulesOfGame ref="rulesOfGame" />
    </div>
  </div>
</template>

<script>
import rulesOfGame from "@/components/rulesOfGame.vue";
import turntable from "@/components/turntable.vue";
export default {
  name: "luckyDraw",
  components: {
    rulesOfGame,
    turntable,
  },
  data() {
    return {};
  },

  mounted() {
   
    // if (localStorage.getItem("token") != null) {
    //   Dialog.alert({
    //     message: "请登录后参与此活动。",
    //     theme: "round-button",
    //   }).then(() => {
    //     localStorage.setItem("path", this.$route.path);
    //     this.$router.push({
    //       path: "/login",
    //       query: { id: this.formData.webTenId },
    //     });
    //   });
    // }
  },
};
</script>

<style scoped>
.luckyDraw {
  width: 100%;
  background: url("../../assets/interacactiveLottery/back.png") no-repeat;
  background-size: 100% auto;
  padding-top: 2.06rem;
}
</style>